export default {"src":"/_next/static/media/icon-linkedin.f6413aa3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};